import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  readTime: string;
  category: string;
  tags: string[];
  image: string;
  featured: boolean;
}

export const useBlogPosts = () => {
  return useQuery({
    queryKey: ['blog-posts'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('blog_posts')
        .select('*')
        .eq('is_published', true)
        .lte('publish_date', new Date().toISOString().split('T')[0])
        .order('publish_date', { ascending: false });

      if (error) {
        console.error('Error fetching blog posts:', error);
        throw error;
      }

      // Transform database format to component format
      return (data || []).map(post => ({
        id: post.id,
        title: post.title,
        excerpt: post.excerpt,
        content: post.content,
        author: post.author,
        date: post.publish_date,
        readTime: post.read_time,
        category: post.category,
        tags: post.tags,
        image: post.image_url,
        featured: post.featured
      })) as BlogPost[];
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
